/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

export default {
  presence: {
    batcherWait: 50,
    batcherMaxCalls: 50,
    batcherMaxWait: 150,
  },
};
